<template>
  <div class="form-container">
    <h2 style="margin: 0 0 16px 0; color: var(--color-ds-primary)">
      Run DataStar Macro
    </h2>
    <div class="form-section">
      <div class="form-group">
        <label>Action Name</label>
        <input
          type="text"
          placeholder="run datastar macro"
          v-model="actionName"
        />
      </div>
      <div class="form-group">
        <label>DataStar Project</label>
        <select v-model="selectedProject">
          <option value="">Select Project</option>
          <option
            v-for="project in projects"
            :key="project.id"
            :value="project"
          >
            {{ project.name }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label>Macro</label>
        <select v-model="selectedMacro" :disabled="!selectedProject">
          <option value="">Select Macro</option>
          <option v-for="macro in macros" :key="macro.id" :value="macro">
            {{ macro.name }}
          </option>
        </select>
      </div>
      <button
        class="button button-full"
        :disabled="!selectedProject || !selectedMacro"
        @click="addWorkflowElement"
      >
        Add Workflow Item
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { getDataStarProjects, getDataStarProjectMacros } from "../services/optilogicService";
import { addWorkflowItem, createRunDataStarMacroWorkflowItem } from '../utils/workflowUtils';

const actionName = ref("");
const selectedProject = ref("");
const selectedMacro = ref("");
const projects = ref([]);
const macros = ref([]);

onMounted(async () => {
  projects.value = await getDataStarProjects();
});

// Reset macro selection and fetch macros when project changes
watch(selectedProject, async (newProject) => {
  selectedMacro.value = "";
  macros.value = [];
  if (newProject) {
    macros.value = await getDataStarProjectMacros(newProject.id);
  }
});

const addWorkflowElement = async () => {

  const { keys, values } = createRunDataStarMacroWorkflowItem(
    actionName.value,
    selectedProject.value.name,
    selectedMacro.value.name
  );

  await addWorkflowItem(keys, values);
}
</script>
